const localizers = {
  'Alerts.noAlerts.txt': () => `Tälle raportille ei ole asetettu hälytyksiä.`,
  'BirdImage.image.txt': () => `Kuva`,
  'ComboBox.clearFilter.txt': () => `Poista suodatin`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Ei tietoja)`,
  'ContextMenu.selectAll.txt': () => `Valitse kaikki`,
  'ContextMenu.clearSelection.txt': () => `Tyhjennä valinta`,
  'ContextMenu.exportImage.txt': () => `Vie kuvana`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: Nouseva`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: Laskeva`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: Lisää nouseva`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: Lisää laskeva`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Poista ${role} lajittelusta`,
  'ContextMenu.removeSortLevel.txt': () => `Poista lajittelutaso`,
  'ContextMenu.sort.txt': () => `Lajittele`,
  'ContextMenu.selectShortestPath.txt': () => `Valitse lyhin polku`,
  'ContextMenu.explain.txt': () => `Tietojen selitykset`,
  'ContextMenu.explainRole.txt': ({role}) => `Selitys ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Hallitse sarakkeita`,
  'ContextMenu.includeMissingValues.txt': () => `Sisällytä puuttuvat arvot`,
  'DrillableTooltip.drill.txt': () => `SIIRRY`,
  'DrillableTooltip.tooltip.txt': () => `TYÖKALUVIHJE`,
  'DrillableTooltip.links.txt': () => `LINKIT`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Sivun linkki kohteeseen ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Raportin linkki kohteeseen ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Ulkoinen linkki kohteeseen ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Ei saatavilla`,
  'Breadcrumb.all.fmt': ({label}) => `Kaikki ${label}`,
  'BrowserCheck.title.txt': () => `WebGL-tarkistus`,
  'BrowserCheck.msg.txt': () => `WebGL on joko pois käytöstä tai selaimesi ei tue sitä.   \nNapsauta OK tarkastellaksesi raporttia perinteisessä katseluohjelmassa.`,
  'EmailUtil.subject.multiple.txt': () => `Tarkistettavat raportit`,
  'EmailUtil.tooLongEmail.txt': () => `Sähköpostin pituusrajoitus ylittyi. Valitse vähemmän raportteja sähköpostiin.`,
  'HiddenSectionDialog.close.txt': () => `Sulje`,
  'HiddenSectionDialog.export.txt': () => `Vie PDF-tiedostona`,
  'InfoPanel.information.txt': () => `Tiedot`,
  'InfoPanel.comments.txt': () => `Kommentit`,
  'InfoPanel.alerts.txt': () => `Ilmoitukset`,
  'IncomingFilters.promptbars.txt': () => `Toimintaohjepalkit`,
  'Information.title.txt': () => `Otsikko`,
  'Information.name.txt': () => `Nimi:`,
  'Information.description.txt': () => `Kuvaus:`,
  'Information.displayRules.txt': () => `Näyttösäännöt:`,
  'Information.graphLevel.txt': () => `Kaaviotaso`,
  'Information.reportLevel.txt': () => `Raportin taso`,
  'Information.legend.txt': () => `Selitykset`,
  'Information.incomingFilters.txt': () => `Tulevat suodattimet:`,
  'Information.noIncomingFilters.txt': () => `Ei tulevia suodattimia`,
  'Information.dataSourceFilters.txt': () => `Tietolähteen suodattimet:`,
  'Information.interactiveFilters.txt': () => `Interaktiiviset suodattimet:`,
  'MobileContainer.mobileBIMessage.txt': () => `Tarkastele SAS-raportteja mobiililaitteellasi.`,
  'ObjectTypes.report.txt': () => `Raportti`,
  'ObjectTypes.Report.BI.txt': () => `SAS-raportti (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Stored process`,
  'MissingValues.label.txt': () => `(puuttuvat arvot)`,
  'PromptContainer.apply.txt': () => `OK`,
  'PromptContainer.cancel.txt': () => `Peruuta`,
  'PromptContainer.close.txt': () => `Sulje`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Arvon on oltava numero väliltä ${min}-${max} (sisällyttävä).`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Määritä kelvollinen numeerinen arvo.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Arvo ei kelpaa määritetyille tiedoille.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Syötä: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Syötä: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Syötä ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} – ${max}`,
  'Slider.missingValues.txt': () => `Puuttuvat arvot`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Takaisin`,
  'ReportContainer.reportCorrupted.txt': () => `RAPORTTI VIOITTUNUT`,
  'ReportContainer.themeLoadFailed.txt': () => `Raportin teeman lataaminen epäonnistui.`,
  'ReportContainer.restoreButton.tip.txt': () => `Palauta raportti`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Raportti palautettu`,
  'ReportContainer.renderError.txt': () => `Tapahtui virhe. Raporttia ei voitu näyttää.`,
  'ReportContainer.component.renderError.txt': () => `Tapahtui virhe. Komponenttia ei voitu hahmontaa.`,
  'ReportContentPage.open.txt': () => `Avaa...`,
  'ReportContentPage.refreshReport.txt': () => `Päivitä raportti`,
  'ReportContentPage.editReport.txt': () => `Muokkaa raporttia`,
  'ReportContentPage.print.txt': () => `Tulosta...`,
  'ReportContentPage.email.txt': () => `Sähköposti...`,
  'ReportContentPage.export.txt': () => `Vie Exceliin...`,
  'ReportContentPage.reportProperties.txt': () => `Raportin ominaisuudet`,
  'ReportContentPage.shareReport.txt': () => `Jaa raportti`,
  'ReportContentPage.enableOverlays.txt': () => `Ota objektien peittokuvat käyttöön`,
  'ReportContentPage.disableOverlays.txt': () => `Poista objektien peittokuvat käytöstä`,
  'ReportContentPage.link.txt': () => `Linkki...`,
  'ReportContentPage.settings.txt': () => `Asetukset...`,
  'ReportContentPage.editPlayback.txt': () => `Muokkaa toistoa`,
  'ReportContentPage.playReport.txt': () => `Toista raportti`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Näytä pyydetyt suodattimet`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Piilota pyydetyt suodattimet`,
  'ReportContentPage.reportFilters.txt': () => `Raportin taso`,
  'ReportContentPage.pageFilters.txt': () => `Sivutaso`,
  'ReportContentPage.refreshRequired.txt': () => `Raportin päivitys on tarpeen`,
  'ReportContentPage.infoButton.tip.txt': () => `Tietopaneeli`,
  'ReportContentPage.backButton.tip.txt': () => `Näytä kaikki raportit`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Lisää asetuksia`,
  'ReportContentPage.itemGroupName.txt': () => `Raportit`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Maksimoi raportti`,
  'ReportContentPage.closeButton.txt': () => `Sulje raportti`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Raportti maksimoitu`,
  'ReportContentPage.resetReportState.txt': () => `Palauta raportin oletustila`,
  'ReportContentPage.summary.txt': () => `Näytä yhteenveto`,
  'ReportManagerPage.objectMenu.open.txt': () => `Avaa`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Muokkaa`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Yhteenveto`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Ominaisuudet`,
  'ReportManagerPage.objectMenu.email.txt': () => `Sähköposti...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Tulosta`,
  'ReportManagerPage.browseReportsButton.txt': () => `Selaa raportteja`,
  'ReportManagerPage.newReportButton.txt': () => `Uusi raportti`,
  'ReportManagerPage.emptyView.message.txt': () => `Raportteja ei löytynyt.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Selaa raportteja`,
  'ReportManagerPage.tableView.name.txt': () => `Nimi`,
  'ReportManagerPage.tableView.author.txt': () => `Tekijä`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Muokattu viimeksi`,
  'ReportManagerPage.openButton.tip.txt': () => `Avaa raportti`,
  'ReportManagerPage.emailButton.tip.txt': () => `Lähetä raportti sähköpostitse`,
  'ReportManagerPage.printButton.tip.txt': () => `Tulosta raportti PDF-tiedostoon`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Raportin ominaisuudet`,
  'ReportObject.multipleReferences.error.txt': () => `Raporttiobjekteja ei voi käyttää useissa konteksteissa.`,
  'ReportObject.notFound.error.txt': () => `Objektin nimeä ei löydy määritetystä raportista.`,
  'ReportObject.invalidPage.error.txt': () => `Määritetty sivu on virheellinen.`,
  'ReportPropertiesDialog.open.txt': () => `Avaa`,
  'ReportPropertiesDialog.close.txt': () => `Sulje`,
  'ReportPropertiesDialog.name.txt': () => `Nimi:`,
  'ReportPropertiesDialog.description.txt': () => `Kuvaus:`,
  'ReportPropertiesDialog.keywords.txt': () => `Avainsanat:`,
  'ReportPropertiesDialog.type.txt': () => `Tyyppi:`,
  'ReportPropertiesDialog.location.txt': () => `Sijainti:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Luonut:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Luontipäivämäärä:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Muokannut:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Muokkauspäivämäärä:`,
  'ReportSections.newPageButton.txt': () => `Uusi sivu`,
  'ReportSections.closeTab.tooltip.txt': () => `Poista sivu`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `${label} -valikko`,
  'ReportSummaryDialog.title.txt': () => `Yhteenveto`,
  'ReportSummaryDialog.open.txt': () => `Avaa`,
  'ReportSummaryDialog.cancel.txt': () => `Peruuta`,
  'ReportSummaryDialog.close.txt': () => `Sulje`,
  'ReportSummaryDialog.noSummary.txt': () => `Yhteenvetoa ei saatavilla.`,
  'ReportTileBody.modifiedBy.txt': () => `Muokannut:`,
  'ReportTileBody.lastModified.txt': () => `Muokattu viimeksi:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `SAS Report Viewer`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Raportin päivitys`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Raportin automaattinen päivitys`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Päivitysten tarkistusväli minuutteina:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Hälytysilmoitukset`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Valitse oletusarvoiset hälytysilmoitukset:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Lähetä sähköpostiviestit`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Lähetä tekstiviestit`,
  'VAViewerSettingsProvider.alert.system.txt': () => `Järjestelmänvalvojan oletusarvo`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Teemat`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Ohita raportin teema ja käytä SAS High Contrast -raporttiteemaa`,
  'ViewerBusyDialog.openReport.txt': () => `Avataan raporttia...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Valmistellaan vientiä...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Valmistellaan tulostusta...`,
  'PDFGeneration.printingReport.txt': () => `Luodaan raportin PDF-tiedostoa. Se ladataan, kun se on valmis.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} pvm ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Valitse toiminto`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Olet saavuttanut hierarkian alimman tason.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Olet saavuttanut kaikkien hierarkioiden alimman tason.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Siirry kohteeseen ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Tilannevedot ${a0} ${a1} kohteessa ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Tallenna kuva`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Tulosta objekti...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Jaa objekti...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Lisää`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Objektin valikko kohteelle ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Näytä SAS® Graphics Acceleratorilla`,
  'ZoomControl.button.tip.txt': () => `Zoomaa`,
  'ZoomControl.button.zoomin.txt': () => `Lähennä`,
  'ZoomControl.button.zoomout.txt': () => `Loitonna`,
  'ZoomControl.button.display.txt': () => `Zoomauksen ohjausobjektit`,
  'ZoomControl.button.reset.txt': () => `Nollaa zoomaus`,
  'ExpandControl.button.expand.txt': () => `Maksimoi näkymä`,
  'ExpandControl.button.restore.txt': () => `Palauta näkymä`,
  'ExpandControl.button.expand.tip.txt': () => `Maksimoi`,
  'ExpandControl.button.restore.tip.txt': () => `Palauta`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Sivun linkkejä ei voida suorittaa, kun tämä objekti on maksimoitu.`,
  'DragModeControl.button.pan.tip.txt': () => `Paneroi`,
  'DragModeControl.button.circular.tip.txt': () => `Pyöreä valinta`,
  'DragModeControl.button.freeform.tip.txt': () => `Vapaamuotoinen valinta`,
  'DragModeControl.button.rectangular.tip.txt': () => `Suorakulmion valinta`,
  'DragModeControl.button.zoom.tip.txt': () => `Zoomaa suorakulmioon`,
  'ReportXMLDialog.title.txt': () => `Raportin XML`,
  'ReportXMLDialog.closeButton.txt': () => `Sulje`,
  'ReportXMLDialog.copyButton.txt': () => `Kopioi leikepöydälle`,
  'ReportXMLDialog.error.txt': () => `Virhe ladattaessa raportin XML-tiedostoa`,
  'ErrorDialog.error.txt': () => `Tapahtui virhe. Ota yhteyttä järjestelmänvalvojaasi.`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - Report Viewer`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Avaa raportti`,
  'OpenReportDialog.reports.txt': () => `Raportit:`,
  'OpenReportDialog.cancel.txt': () => `Peruuta`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} objektia päivitetty`,
  'AriaLive.oneObjectUpdated.txt': () => `1 objekti päivitetty`,
  'AriaLive.reportOpened.txt': () => `Raportti avattu`,
  'AriaLive.reportClosed.txt': () => `Raportti suljettu`,
  'ExportData.generating.txt': () => `Luodaan vientitiedostoa. Se ladataan, kun se on valmis.`,
  'ExportData.warning.txt': () => `Virhe luotaessa tietoja`,
  'ExportData.nodata.txt': () => `Ei vietäviä tietoja`,
  'ExportData.exportData.txt': () => `Vie tiedot...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Tallenna`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Peruuta`,
  'PlaybackAnimationDialog.playButton.txt': () => `Toista raportti`,
  'PlaybackAnimationDialog.title.txt': () => `Muokkaa toistoa`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Siirtymäyksikkö:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Sivu`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Objekti`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Sekuntia yksikköä kohti:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Näytä maksimoidut objektit:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Näytä vain piirtoalustat:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Näytä ajastin:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Näytä siirtymisohjausobjektit napsauttaessa tai koskettaessa:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Edellinen sivu`,
  'PlaybackNavigationControls.nextPage.txt': () => `Seuraava sivu`,
  'PlaybackNavigationControls.previousObject.txt': () => `Edellinen objekti`,
  'PlaybackNavigationControls.nextObject.txt': () => `Seuraava objekti`,
  'TransportConnection.generateReportTimeout.txt': () => `Raportin latautuminen kestää kauan. Haluatko jatkaa?`,
  'TransportConnection.openReport.txt': () => `Avaa raportti`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Määritettyä raporttia ei ole seuraavassa kohteessa: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Laajenna ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Kutista ${label}`,
  'GraphElementDecorator.overview.txt': () => `Yleiskatsaus`,
  'GraphElementDecorator.layers.txt': () => `Piilota tai näytä kerrokset`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Piilota yleiskatsaus`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Näytä yleiskatsaus`,
  'TitleInfoButton.tooltip.txt': () => `Tiedot`,
  'SectionSelectionBar.noSelections.txt': () => `Ei valintoja`,
  'SectionSelectionBar.title.txt': () => `Suodattimet:`,
  'CheckboxList.selectAll.txt': () => `Valitse kaikki`,
  'CheckboxList.clearSelection.txt': () => `Tyhjennä valinta`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Tyhjennä valinta (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Selitykset ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Valmistellaan selitystä...`,
  'ExplanationInfoDialog.cancel.txt': () => `Peruuta`,
  'ExplanationInfoDialog.close.txt': () => `Sulje`,
  'PromptHeader.emptyReport.txt': () => `Luo raportin toimintaohje vetämällä tietokohde tai ohjausobjekti tähän.`,
  'PromptHeader.emptyPage.txt': () => `Luo sivun toimintaohjeet vetämällä tietokohde tai ohjausobjekti tähän.`,
  'PromptHeader.collapsePageControlArea.txt': () => `Kutista sivun ohjausalue`,
  'PromptHeader.expandPageControlArea.txt': () => `Laajenna sivun ohjausaluetta`,
  'PromptHeader.collapseReportControlArea.txt': () => `Kutista raportin ohjausalue`,
  'PromptHeader.expandReportControlArea.txt': () => `Laajenna raportin ohjausaluetta`,
  'PromptHeader.collapseControlArea.txt': () => `Kutista ohjausalue`,
  'PromptHeader.expandControlArea.txt': () => `Laajenna ohjausaluetta`,
  'PromptHeader.reportControlArea.txt': () => `Raportin ohjausalue`,
  'PromptHeader.allControlAreas.txt': () => `Kaikki ohjausalueet`,
  'PromptHeader.pageControlArea.txt': () => `Sivun ohjausalue`,
  'ZeroState.editMode.txt': () => `Vedä malli, tietokohteet tai objektit tähän.`,
  'ZeroState.viewMode.txt': () => `Ei näytettävää sisältöä.`,
  'ObjectStatus.assignData.txt': () => `Määritä tiedot`,
  'ObjectStatus.selectImage.txt': () => `Valitse kuva`,
  'ObjectStatus.selectJob.txt': () => `Valitse työ`,
  'ObjectStatus.cancelLoading.txt': () => `Peruuta lataus`,
  'ObjectStatus.loadingCanceled.txt': () => `Lataus peruutettu`,
  'ObjectStatus.resumeLoading.txt': () => `Jatka latausta`,
  'ObjectStatus.refresh.txt': () => `Päivitä`,
  'ObjectStatus.setJobParameters.txt': () => `Aseta parametriarvot`,
  'ObjectSearch.title.txt': () => `Maantieteellinen haku`,
  'ObjectSearch.pin.txt': () => `Kiinnitä`,
  'ObjectSearch.unpin.txt': () => `Poista kiinnitys`,
  'MainSearchPanel.searchHints.txt': () => `Hakuvinkit`,
  'MainSearchPanel.searchResults.txt': () => `Hakutulokset`,
  'MainSearchPanel.features.txt': () => `Ominaisuudet`,
  'MainSearchPanel.pin.txt': () => `Uusi nasta`,
  'MainSearchPanel.pin.tooltip.txt': () => `Uusi nasta`,
  'MainSearchPanel.route.txt': () => `Uusi reitti`,
  'MainSearchPanel.route.tooltip.txt': () => `Uusi reitti`,
  'MainSearchPanel.geographicArea.txt': () => `Uusi maantieteellinen alue`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `Uusi maantieteellinen alue`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Oman sijainnin nasta`,
  'MainSearchPanel.myLocationPin.txt': () => `Oma sijainti`,
  'MainSearchPanel.show.txt': () => `Näytä`,
  'MainSearchPanel.show.all.txt': () => `Näytä kaikki`,
  'MainSearchPanel.hide.txt': () => `Piilota`,
  'MainSearchPanel.hide.all.txt': () => `Piilota kaikki`,
  'MainSearchPanel.delete.txt': () => `Poista`,
  'MainSearchPanel.delete.all.txt': () => `Poista kaikki`,
  'MainSearchPanel.convert.txt': () => `Muunna hakutulokset nastoiksi`,
  'MainSearchPanel.convert.all.txt': () => `Muunna kaikki hakutulokset nastoiksi`,
  'MainSearchPanel.showPinLabels.txt': () => `Näytä nastojen otsikot`,
  'MainSearchPanel.close.label.txt': () => `Maantieteellinen haku`,
  'MainSearchPanel.navigate.tooltip.txt': () => `Näytä tiedot`,
  'MainSearchPanel.demographics.tooltip.txt': () => `Väestötiedot`,
  'PanelHeader.back.tooltip.txt': () => `Takaisin`,
  'GeographicAreaPanel.title.txt': () => `Maantieteellinen alue`,
  'GeographicAreaPanel.draw.txt': () => `Piirrä alue`,
  'GeographicAreaPanel.update.txt': () => `Päivitä alue`,
  'GeographicAreaPanel.label.txt': () => `Otsikko:`,
  'GeographicAreaPanel.location.txt': () => `Sijainti:`,
  'GeographicAreaPanel.distance.miles.txt': () => `Etäisyys (mi):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `Etäisyys (km):`,
  'GeographicAreaPanel.distance.add.txt': () => `Lisää etäisyys`,
  'GeographicAreaPanel.time.add.txt': () => `Lisää aika`,
  'GeographicAreaPanel.distance.delete.txt': () => `Poista etäisyys`,
  'GeographicAreaPanel.time.minutes.txt': () => `Aika (min):`,
  'GeographicAreaPanel.duration.txt': () => `Kesto:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Mailit`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Kilometrit`,
  'GeographicAreaPanel.menu.clear.txt': () => `Tyhjennä maantieteellinen alue`,
  'GeographicAreaPanel.menu.link.txt': () => `Linkitä osoite tietoelementteihin ja nastoihin oletuksena`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Poista linkitys maantieteellisen alueen osoitteesta`,
  'GeographicAreaPanel.menu.delete.txt': () => `Poista maantieteellinen alue`,
  'GeographicAreaPanel.demographics.txt': () => `Väestötiedot`,
  'GeographicAreaPanel.demographics.set.txt': () => `Näytä väestötiedot`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Laajenna näkymää`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Muokkaa väestötietoja`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Poista väestötiedot`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Väestötiedot tulee ladata uudelleen`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Lataa väestötiedot uudelleen`,
  'GeographicAreaPanel.invalid.location.txt': () => `Maantieteellisellä alueella ei ole kelvollista sijaintia, eikä sitä voida luoda.`,
  'TravelTypeField.dateselector.tooltip.txt': () => `Valitse päivä ja aika`,
  'TravelTypeField.cancel.txt': () => `Peruuta`,
  'TravelTypeField.ok.txt': () => `OK`,
  'TravelTypeField.button.tooltip.txt': () => `Valitse päivä ja aika`,
  'TravelTypeField.day.txt': () => `Päivä:`,
  'TravelTypeField.time.txt': () => `Aika:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `Suora`,
  'TravelTypeField.distanceTypes.distance.txt': () => `Etäisyys`,
  'TravelTypeField.travelType.txt': () => `Matkustustyyppi:`,
  'TravelTypeField.traffic.txt': () => `Sisällytä liikenne:`,
  'TravelTypeField.traffic.offset.txt': () => `Liikenne aikaero:`,
  'TravelTypeField.traffic.daytime.txt': () => `Liikenne päivä ja aika:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `Etäisyysyksikkö`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `Ajomatka`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `Ajoaika`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `Kuljetusetäisyys`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `Kuljetusaika`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `Kävelymatka`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `Kävelyaika`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `Ei`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `Nykyinen liikenne`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `Tyypillinen liikenne`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} h`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `Päivitä liikenne tälle ominaisuudelle`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `Päivitä liikenne kaikille ominaisuuksille`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `Päivitä liikennetiedot`,
  'RoutePanel.title.txt': () => `Reitti`,
  'RoutePanel.draw.txt': () => `Piirrä reitti`,
  'RoutePanel.update.txt': () => `Päivitä reitti`,
  'RoutePanel.label.txt': () => `Otsikko:`,
  'RoutePanel.locations.txt': () => `Sijainnit`,
  'RoutePanel.menu.clear.txt': () => `Tyhjennä reitti`,
  'RoutePanel.menu.reverse.txt': () => `Käänteinen reitti`,
  'RoutePanel.menu.add.waypoint.txt': () => `Lisää reitin sijainti`,
  'RoutePanel.menu.delete.waypoint.txt': () => `Poista reitin sijainti`,
  'RoutePanel.menu.unlink.txt': () => `Poista reitin sijainnin linkitys`,
  'RoutePanel.menu.arrows.txt': () => `Reittinuolet`,
  'RoutePanel.menu.arrows.hide.txt': () => `Piilota reittinuolet`,
  'RoutePanel.menu.arrows.show.txt': () => `Näytä reittinuolet`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Yksisuuntainen`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Kaksisuuntainen`,
  'RoutePanel.menu.delete.txt': () => `Poista reitti`,
  'RoutePanel.route.width.txt': () => `Reitin leveys`,
  'RoutePanel.distance.txt': () => `Etäisyys:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} mi`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} km`,
  'RoutePanel.location.add.txt': () => `Lisää sijainti`,
  'RoutePanel.location.delete.txt': () => `Poista sijainti`,
  'RoutePanel.duration.txt': () => `Aika:`,
  'RoutePanel.invalid.location.txt': () => `Reitillä ei ole kelvollisia sijainteja, eikä sitä voida luoda.`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `Sijainti ${index}, ${location}, syöte`,
  'PinPanel.pinTitle.txt': () => `Nasta`,
  'PinPanel.addDescription.txt': () => `Lisää kuvaus`,
  'PinPanel.deleteDescription.txt': () => `Poista kuvaus`,
  'PinPanel.newPin.txt': () => `Uusi nasta tässä sijainnissa`,
  'PinPanel.deletePin.txt': () => `Poista nasta`,
  'PinPanel.linkPins.txt': () => `Linkitä nastat oletuksena tietoelementteihin`,
  'PinPanel.unlinkAllItems.txt': () => `Poista kaikkien kohteiden linkitys`,
  'PinPanel.unlinkItems.txt': () => `Poista kohteiden linkitys`,
  'PinPanel.label.txt': () => `Otsikko:`,
  'PinPanel.location.txt': () => `Sijainti:`,
  'PinPanel.description.txt': () => `Kuvaus:`,
  'PinPanel.linked.txt': () => `LINKITETTY`,
  'PinPanel.searchClickPlaceholder.txt': () => `Hae tai valitse kartalta`,
  'PinPanel.searchPlaceholder.txt': () => `Haku`,
  'PinPanel.addRoute.txt': () => `Lisää reitti`,
  'PinPanel.addRoute.tooltip.txt': () => `Lisää reitti`,
  'PinPanel.addArea.txt': () => `Lisää maantieteellinen alue`,
  'PinPanel.addArea.tooltip.txt': () => `Lisää maantieteellinen alue`,
  'PinPanel.addArea.title.txt': () => `Lisää maantieteellinen alue`,
  'PinPanel.myLocationTitle.txt': () => `Oman sijainnin nasta`,
  'PinPanel.deleteMyLocationPin.txt': () => `Poista oman sijainnin nasta`,
  'PinPanel.enableAutoUpdate.txt': () => `Ota käyttöön oman sijainnin automaattinen päivitys`,
  'PinPanel.disableAutoUpdate.txt': () => `Poista käytöstä oman sijainnin automaattinen päivitys`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Muokkaa oman sijainnin automaattista päivitysväliä...`,
  'PinPanel.linkToPin.txt': () => `Linkitä nastaan`,
  'PinPanel.useCurrentLocation.txt': () => `Käytä nastan nykyistä sijaintia`,
  'PinPanel.notDrawn.txt': () => `Ei piirretty`,
  'PinPanel.undetermined.txt': () => `Määrittämätön`,
  'PinPanel.findMyLocation.txt': () => `Hae oma sijainti`,
  'PinPanel.cannotDetermineLocation.txt': () => `Sovellus ei voi määrittää nykyistä sijaintiasi. Jos haluat jakaa sijaintisi, katso selaimesi tai laitteesi ohje.`,
  'PinPanel.autoRefreshInterval.txt': () => `Oman sijainnin automaattinen päivitysväli`,
  'PinPanel.interval.hours.txt': () => `Tunnit:`,
  'PinPanel.interval.minutes.txt': () => `Minuutit:`,
  'PinPanel.interval.seconds.txt': () => `Sekunnit:`,
  'PinPanel.invalid.location.txt': () => `Nastalla ei ole kelvollista sijaintia, eikä sitä voida luoda.`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} mi`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}; ${value2} mi`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} mi`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} km`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}; ${value2} km`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} km`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} min`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}; ${value2} min`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}; ${value2}; ${value3} min`,
  'PinPanel.clearLocation.tooltip.txt': () => `Tyhjennä sijaintiteksti`,
  'DiscardChangesDialog.title.area.txt': () => `Maantieteellinen alue`,
  'DiscardChangesDialog.title.route.txt': () => `Reitti`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `Teit muutoksia maantieteelliseen alueeseen, mutta et piirtänyt aluetta uudelleen.\n\nHaluatko hylätä muutokset kohteeseen ${label}?`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `Teit muutoksia maantieteelliseen reittiin, mutta et piirtänyt reittiä uudelleen.\n\nHaluatko hylätä muutokset kohteeseen ${label}?`,
  'DiscardChangesDialog.discard.txt': () => `Hylkää`,
  'DiscardChangesDialog.cancel.txt': () => `Peruuta`,
  'FeatureErrorDialog.title.area.txt': () => `Piirrä maantieteellinen alue`,
  'FeatureErrorDialog.title.route.txt': () => `Piirrä reitti`,
  'FeatureErrorDialog.text.area.txt': () => `Maantieteellistä aluetta ei voitu piirtää..\n\nVinkki: Jos alueesi sijainnissa ei ole liikenneinfrastruktuuria (esim. teitä), maantieteellisen alueen laskeminen ei välttämättä ole mahdollista. Käytä sen sijaan etäisyyteen perustuvaa matkustustyyppiä tai siirrä alue sijaintiin, jossa on liikenneinfrastruktuuri.`,
  'FeatureErrorDialog.text.route.txt': () => `Reittiä ei voitu piirtää..\n\nVinkki: Jos reittisi sijainnissa ei ole liikenneinfrastruktuuria (esim. teitä), reitin laskeminen ei välttämättä ole mahdollista. Käytä sen sijaan etäisyyteen perustuvaa matkustustyyppiä tai siirrä reitti sijaintiin, jossa on liikenneinfrastruktuuri.`,
  'FeatureErrorDialog.close.txt': () => `Sulje`,
  'DemographicsSelectorDialog.title.txt': () => `Näytä väestötiedot`,
  'DemographicsSelectorDialog.cancel.txt': () => `Peruuta`,
  'DemographicsSelectorDialog.ok.txt': () => `OK`,
  'DemographicsSelectorDialog.country.txt': () => `Maa/alue`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Perus`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Lisäasetukset`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Viimeisimmät`,
  'DemographicsSelectorDialog.categories.txt': () => `Luokat`,
  'DemographicsSelectorDialog.category.income.txt': () => `Tulot`,
  'DemographicsSelectorDialog.category.age.txt': () => `Ikä`,
  'DemographicsSelectorDialog.category.households.txt': () => `Kotitaloudet`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Asuminen`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Siviilisääty`,
  'DemographicsSelectorDialog.category.population.txt': () => `Väestö`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Käyttäjäryhmä`,
  'DemographicsSelectorDialog.category.health.txt': () => `Terveys`,
  'DemographicsSelectorDialog.category.education.txt': () => `Koulutus`,
  'DemographicsSelectorDialog.category.business.txt': () => `Liiketoiminta`,
  'DemographicsSelectorDialog.category.race.txt': () => `Rotu`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Kulutus`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Käyttäytymiset`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Työt`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Köyhyys`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Seinävaate`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `Vaarassa`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Tärkeimmät tosiasiat`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Tarjonta ja kysyntä`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Käytäntö`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Maisema`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Rikokset`,
  'ManageColumns.title.txt': () => `Hallitse sarakkeita`,
  'ManageColumns.ok.txt': () => `OK`,
  'ManageColumns.cancel.txt': () => `Peruuta`,
  'ManageColumns.hiddenColumns.txt': () => `Piilotetut sarakkeet`,
  'ManageColumns.displayedColumns.txt': () => `Näytetyt sarakkeet`,
  'SearchResultPanel.title.txt': () => `Hakutulokset`,
  'SearchResultPanel.menu.delete.txt': () => `Poista hakutulos`,
  'SearchResultPanel.convert.txt': () => `Muunna nastaksi`,
  'SearchResultPanel.convert.tooltip.txt': () => `Muunna nastaksi`,
  'DemographicsResultsDialog.title.txt': () => `Väestötiedot`,
  'DemographicsResultsDialog.cancel.txt': () => `Peruuta`,
  'DemographicsResultsDialog.close.txt': () => `Sulje`,
  'DemographicsResultsDialog.edit.txt': () => `Muokkaa`,
  'DemographicsResultsDialog.layout.page.txt': () => `Karusellinäkymä`,
  'DemographicsResultsDialog.layout.list.txt': () => `Yhden sarakkeen näkymä`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Ruutunäkymä`,
  'DemographicsResultsDialog.noData.txt': () => `Tiedot eivät vastaa nykyistä maantieteellistä aluetta.`,
  'PinsAtSameLocationPanel.title.txt': () => `Nastat samassa sijainnissa`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `HAKUTULOKSET`,
  'PinsAtSameLocationPanel.pins.txt': () => `NASTAT`,
  'PinsAtSameLocationPanel.showAll.txt': () => `Näytä kaikki`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `Piilota kaikki`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `Poista kaikki`,
  'PinsAtSameLocationPanel.show.txt': () => `Näytä`,
  'PinsAtSameLocationPanel.hide.txt': () => `Piilota`,
  'PinsAtSameLocationPanel.delete.txt': () => `Poista`,
  'LocationPopover.pin.title.txt': () => `Nastan sijainti`,
  'LocationPopover.area.title.txt': () => `Maantieteellisen alueen sijainti`,
  'LocationPopover.route.title.txt': ({label}) => `Reitin sijainti ${label}`,
  'LocationPopover.name.txt': () => `Nimi`,
  'LocationPopover.location.txt': () => `Sijainti:`,
  'LocationPopover.ok.txt': () => `Aseta sijainti`,
  'LocationPopover.cancel.txt': () => `Poistu valintatilasta`,
  'LocationPopover.hint.txt': () => `Napsauta karttaa uudelleen tunnistaaksesi toisen sijainnin.`,
  'TreeDualSelector.source.default.txt': () => `Käytettävissä olevat kohteet`,
  'TreeDualSelector.target.default.txt': () => `Valitut kohteet`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} / ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `Ei kohteita`,
  'TreeDualSelector.filter.placeholder.txt': () => `Suodatin`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `Mukautettu kohde`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} kohdetta lisätty`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} kohdetta poistettu`,
  'TreeDualSelector.afterAction.addAll.txt': () => `Kaikki kohteet on lisätty`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `Kaikki kohteet on poistettu`,
  'TreeDualSelector.afterAction.up.txt': () => `Siirretty ylös`,
  'TreeDualSelector.afterAction.down.txt': () => `Siirretty alas`,
  'TreeDualSelector.afterAction.top.txt': () => `Siirretty alkuun`,
  'TreeDualSelector.afterAction.bottom.txt': () => `Siirretty loppuun`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `Lisäystoiminto palautettu`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `Poistotoiminto palautettu`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `mukautettu kohde lisätty`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} mukautettu kohde valittu`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} valittu`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} valittu`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `Siirry yksi rivi ylöspäin kohteessa ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `Siirry yksi rivi alaspäin kohteessa ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `Siirry kohteen ${targetListLabel} alkuun`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `Siirry kohteen ${targetListLabel} loppuun`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `Lisää kohde kohteeseen ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `Lisää kaikki kohteeseen ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `Poista kohde kohteesta ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `Poista kaikki kohteesta ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `Kumoa lisäys kohteeseen ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `Kumoa poisto kohteesta ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `Suodata ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `Poista`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `Kaikki poistettavaksi valitsemasi mukautetut kohteet poistetaan pysyvästi, jos jatkat.\n\n Haluatko jatkaa?`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `Poista kaikki kohteet`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `Tämän luettelon mukautetut kohteet poistetaan pysyvästi, jos jatkat.\n\n Haluatko jatkaa?`,
  'LinkNavigator.backButton.label': () => `Takaisin`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `Tulevat suodattimet`,
  'LinkNavigator.reportLevel.label': () => `Raportin taso`,
  'LinkNavigator.sectionLevel.label': () => `Sivutaso`,
  'ReportSectionZeroState.heading.label': () => `Laadi raportti`,
  'ReportSectionZeroState.description.label': () => `Vedä objekteja tai tietokohteita sivulle tai valitse vaihtoehto alta.`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `Vedä objektit tai tietokohteet sivulle tai aloita sivumallista.`,
  'ReportSectionZeroState.autoChartButton.label': () => `Luo objekti`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `Valitse pohja`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `Tutustu ehdotuksiin`,
  'PromptContainerTooltip.noSelections.txt': () => `Ei valintoja`,
  'PromptContainerTooltip.selectedValues.txt': () => `Valitut arvot`,
}
export default localizers;
